export default function NotFound() {
  return <div id="error-page">Not Found</div>;
}
